import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Skills from './views/Skills.vue'
import Project from './views/Project.vue'
import Contact from './views/Contact.vue'
import Stock from './views/Stock.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/skills',
      name: 'skills',
      component: Skills
    },
    {
      path: '/projects',
      name: 'projects',
      component: Project
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/stock',
      name: 'stock',
      component: Stock
    }
  ]
})
